import React, { useState } from "react";
import "./Contact.css";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    Phone: "",
    Email: "",
    Service: "",
    Message: "",
  });

  const [resultMessage, setResultMessage] = useState("");

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Email validation
    const emailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailValid.test(formData.Email)) {
      alert("Please enter a valid email address");
      return;
    }

    // Phone validation
    const phoneValid = /^[0-9]{10}$/;
    if (!phoneValid.test(formData.Phone)) {
      alert("Enter number must be 10 digits");
      return;
    }

    // Send to Google Sheets
    fetch("https://script.google.com/macros/s/AKfycbwAmdbVBrg0EGMG-WizU1N1iY73lHiAuB-85xhLfN4vj5emR8mNp0ouesd5_AFbUh9g/exec", {
      method: "POST",
      mode: "no-cors",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });

    // Send to Web3Forms
    const web3formsData = {
      access_key: "ae2fa142-46e9-4841-abfb-7fa49afbbb72", // replace this
      name: formData.name,
      email: formData.Email,
      phone: formData.Phone,
      service: formData.Service,
      message: formData.Message,
    };

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(web3formsData),
      });

      const data = await response.json();

      if (data.success) {
        setResultMessage("We have received your message. Our team will respond to you within 1-2 business days.");
        e.target.reset();
        setFormData({
          name: "",
          Phone: "",
          Email: "",
          Service: "",
          Message: "",
        });
      } else {
        setResultMessage(`Error: ${data.message}`);
      }
    } catch (error) {
      setResultMessage("An error occurred during submission. Please make changes and try again.");
    }
  };

  return (
    <section id="contact" className="contact-section">
      <h2>Book a Session</h2>
      <form className="contact-form" onSubmit={handleSubmit}>
        <input
          type="text"
          name="name"
          placeholder="Your Name"
          value={formData.name}
          onChange={handleChange}
          required
        />
        <input
          type="number"
          name="Phone"
          placeholder="Your Number"
          value={formData.Phone}
          onChange={handleChange}
          required
        />
        <input
          type="email"
          name="Email"
          placeholder="Your Email"
          value={formData.Email}
          onChange={handleChange}
          required
        />
        <select
          name="Service"
          value={formData.Service}
          onChange={handleChange}
          required
        >
          <option value="" disabled>
            Select a Service
          </option>
          <option value="Dance Movement Therapy">Dance Movement Therapy</option>
          <option value="Gestalt Psychotherapy">Gestalt Psychotherapy</option>
          <option value="Counseling Supervision">Counseling Supervision</option>
          <option value="Individual Counseling">Individual Counseling</option>
          <option value="Group Counseling">Group Counseling</option>
          <option value="Couple Counseling">Couple Counseling</option>
          <option value="Yog Teacher's Training">Yog Teacher's Training</option>
          <option value="Yoga Therapy">Yoga Therapy</option>
        </select>
        <textarea
          name="Message"
          placeholder="You can leave your message here, and we will get back to you as soon as possible."
          rows="5"
          value={formData.Message}
          onChange={handleChange}
          required
        />
        <button type="submit">Send</button>
      </form>
      {resultMessage && <p style={{ marginTop: "1rem", color: "green" }}>{resultMessage}</p>}
    </section>
  );
};

export default Contact;
